module.exports = __webpack_public_path__ + "img/btn.60fba265.svg";